import React from 'react';
import { CHART_COLORS } from '../../utils/rollup';
import { fmtMoney } from './format';

export default function ShareList({ data }) {
  const total = (data || []).reduce((s, d) => s + d.amount, 0);

  return (
    <div style={{ flex: 1, minWidth: 260 }}>
      {(data || []).map((d, i) => {
        const pct = total ? ((d.amount / total) * 100).toFixed(1) : '0.0';
        return (
          <div key={d.name} style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            marginBottom: 10,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div style={{
                width: 12, height: 12, borderRadius: '50%', flexShrink: 0,
                background: CHART_COLORS[i % CHART_COLORS.length],
              }} />
              <span style={{ fontWeight: 600, color: '#111827' }}>{d.name}</span>
            </div>
            <div style={{ textAlign: 'right' }}>
              <span style={{ fontWeight: 700, color: '#111827' }}>{fmtMoney(d.amount)}</span>{' '}
              <span style={{ color: '#6b7280' }}>({pct}%) • {d.hours.toFixed(2)} hrs</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
